import { LicenseInfo } from "@mui/x-license";

export const setMuiLicenseKey = () => {
  LicenseInfo.setLicenseKey(
    "5fef57ba9c0ffe451a6eaaa59e2fbb58Tz0xMjE5NDgsRT0xNzk1MTMyNzk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTIsS1Y9Mg==",
  );
};
